import { SETTLEMENT_STATUSES as statuses } from '../../utils/constants';

/**
 * If true, display the order acceptance step as 'done' instead of in progress
 * @returns {boolean}
 */
export function orderAcceptanceDone({ settlement }) {
  return Boolean(settlement.status && settlement.status !== statuses.draft);
}

/**
 * If true, display the settlement readiness step to be awaiting document completion.
 * This will be overridden by the settlement readiness done state.
 * @returns {boolean}
 */
export function settlementReadinessDocumentsReady({ settlement }) {
  const doneStatuses = [statuses.documentsReady];
  return doneStatuses.includes(settlement.status);
}

/**
 * If true, display the settlement readiness step as 'done' instead of in progress.
 * This will override the settlement documents ready state.
 * @returns {boolean}
 */
export function settlementReadinessDone({ settlement }) {
  const doneStatuses = [
    statuses.documentsApproved,
    statuses.carReady,
    statuses.carDelivered
  ];
  return doneStatuses.includes(settlement.status);
}

/**
 * If true, display the car readiness step as 'done' instead of in progress
 * @returns {boolean}
 */
export function carReadinessDone({ settlement }) {
  const doneStatuses = [statuses.carReady, statuses.carDelivered];
  return doneStatuses.includes(settlement.status);
}

/**
 * If true, display the car delivery step as 'done' instead of in progress
 * @returns {boolean}
 */
export function carDeliveredDone({ settlement }) {
  return settlement.status === statuses.carDelivered;
}

/**
 * If true, display the order acceptance step
 * @returns {boolean}
 */
export function showOrderAcceptanceStep({ settlement }) {
  const visibleStatuses = [
    undefined,
    statuses.draft,
    statuses.orderAccepted,
    statuses.documentsReady
  ];
  return visibleStatuses.includes(settlement.status);
}

/**
 * If true, display the settlement readiness step
 * @returns {boolean}
 */
export function showSettlementReadinessStep({ settlement }) {
  const visibleStatuses = [
    statuses.orderAccepted,
    statuses.documentsReady,
    statuses.documentsApproved
  ];
  return visibleStatuses.includes(settlement.status);
}

/**
 * If true, display the car readiness step
 * @returns {boolean}
 */
export function showCarReadinessStep({ settlement }) {
  const visibleStatuses = [statuses.documentsApproved, statuses.carReady];
  return visibleStatuses.includes(settlement.status);
}

/**
 * If true, display the car delivery step
 * @returns {boolean}
 */
export function showCarDeliveredStep({ settlement }) {
  return settlement.status === statuses.carReady;
}

export function settlementSteps(state) {
  return [
    {
      title: 'Employer Approved',
      slotName: 'employerApproved',
      done: true,
      name: 'hide'
    },
    {
      title: 'Order Acceptance',
      slotName: 'orderAcceptance',
      icon: 'icon-order-acceptance',
      done: orderAcceptanceDone(state),
      name: showOrderAcceptanceStep(state)
    },
    {
      title: 'Settlement Readiness',
      slotName: 'settlementReadiness',
      icon: 'icon-settlement-readiness',
      done: settlementReadinessDone(state),
      name: showSettlementReadinessStep(state)
    },
    {
      title: 'Car Readiness',
      slotName: 'carReadiness',
      icon: 'icon-car-readiness',
      done: carReadinessDone(state),
      name: showCarReadinessStep(state)
    },
    {
      title: 'Car Delivered',
      slotName: 'carDelivered',
      icon: 'icon-car-delivery',
      done: carDeliveredDone(state),
      name: showCarDeliveredStep(state)
    }
  ];
}
